import { FC } from "react";
import { FieldInputProps } from "react-final-form";

import { IPickerListItem, Picker } from "@livechat/design-system-react-components";

import { TicketStatus, TicketStatusFormattedValues } from "interfaces/entities/ticket";
import { shortPickerStyles } from "routes/automations/shared/styles";
import { IRuleTriggerStatus } from "store/entities/rules/interfaces";

import { changeTriggerValues } from "../utils";

interface IProps {
  input: FieldInputProps<IRuleTriggerStatus>;
}

export const StatusTrigger: FC<IProps> = ({ input }) => {
  const equalityOptions = [createEqualityOption("is"), createEqualityOption("isNot")];

  const selectedEqualityOptions = [createEqualityOption(input.value.invert ? "isNot" : "is")];

  const handleSelectEqualityOption = (selectedOptions: IPickerListItem[] | null): void => {
    if (!selectedOptions || selectedOptions.length === 0) {
      return;
    }

    const selectedOption = selectedOptions[0];
    const newInvert = selectedOption.key === "isNot";
    changeTriggerValues(input, { invert: newInvert });
  };

  const statusOptions = Object.values(TicketStatus).map(createStatusOption);

  const selectedStatusOptions = input.value.in.map(createStatusOption);

  const handleSelectStatus = (selectedOptions: IPickerListItem[] | null): void => {
    if (!selectedOptions) {
      changeTriggerValues(input, { in: [] });
      return;
    }

    const newStatuses = selectedOptions.map(opt => opt.key);
    changeTriggerValues(input, { in: newStatuses });
  };

  return (
    <>
      <Picker
        options={equalityOptions}
        selected={selectedEqualityOptions}
        onSelect={handleSelectEqualityOption}
        hideClearButton
        searchDisabled
        css={shortPickerStyles}
      />
      <Picker
        type="multi"
        options={statusOptions}
        selected={selectedStatusOptions}
        onSelect={handleSelectStatus}
        searchDisabled
        placeholder="Select one status or more..."
      />
    </>
  );
};

const createEqualityOption = (key: "isNot" | "is"): IPickerListItem => ({
  key,
  name: key === "isNot" ? "is not" : "is",
});

const createStatusOption = (status: TicketStatus): IPickerListItem => ({
  key: status,
  name: TicketStatusFormattedValues[status],
});
